import { RoleModel, UserPhoneModel, ChangePasswordModel } from './../definition/user.model';
import { Injectable, Injector } from '@angular/core';
import { GenericApiService } from './generic-api.service';
import { HttpClient } from '@angular/common/http';
import { UserModel } from 'shared/definition';

@Injectable({
  providedIn: 'root'
})
export class UserApiService extends GenericApiService<UserModel, any>{

  constructor(injector: Injector) {
    super(injector, 'user')
  }

  getUserRoles(userId: string) {
    return this.httpClient.get<RoleModel[]>(`${this.apiUrl}/userole/${userId}`);
  }

  updateUserPhone(model: UserPhoneModel) {
    return this.httpClient.post<UserModel[]>(`${this.apiUrl}/${model.userId}/phone`, model);
  }

  getCurrentUser() {
    return this.httpClient.get<UserModel>(`${this.apiUrl}/current`);
  }

  changePassword(model: ChangePasswordModel) {
    return this.httpClient.post<any>(`${this.apiUrl}/${model.userId}/changepassword`, model);
  }

  getUserList(){
    return this.httpClient.get<UserModel[]>(`${this.apiUrl}`);
  }

}
